module.exports = __webpack_public_path__ + "static/media/20_l_stena_0.68_0.35ba53ad.png";